@if (searchCriteria) {
  <div class="columns">
    <div class="column">
      @if (noResultsFound) {
        <section class="section">
          <div class="container">
            <div class="subtitle has-text-centered">
              <h2 class="has-text-weight-bold">
                No results found. Please check your search criteria.
              </h2>
            </div>
          </div>
        </section>
      }
      @if (results && results.length > 0) {
        <div>
          <table class="table is-fullwidth is-striped ">
            <thead>
              <tr role="row" class="is-selected">
                @for (column of columns; track column) {
                  @if (column.display) {
                    <th class="table-header" [mcTableSorting]="config" [column]="column" title="{{column.title}}"
                      (sortChanged)="onChangeTable($event)" ngClass="{{column.className || ''}}">
                      <span> {{column.title}}</span>
                      @if (config && column.sort != undefined) {
                        <span class="sort is-text-centered">
                          @if (column.sort === '') {
                            <span>
                              <i class="fas fa-sort"></i>
                            </span>
                          }
                          @if (column.sort === 'desc') {
                            <span>
                              <i class="fas fa-sort-down"></i>
                            </span>
                          }
                          @if (column.sort === 'asc') {
                            <span>
                              <i class="fas fa-sort-up"></i>
                            </span>
                          }
                        </span>
                      }
                    </th>
                  }
                }
              </tr>
            </thead>
            <tbody>
              @if (showFilterRow) {
                <tr>
                  @for (column of columns; track column) {
                    <td>
                      @if (column.filtering) {
                        <input placeholder="{{column.filtering.placeholder}}"
                          [mcTableFiltering]="column.filtering"
                          class="form-control" (tableChanged)="onChangeTable(config)" />
                      }
                    </td>
                  }
                </tr>
              }
              @for (row of rows; track row) {
                <tr>
                  <td>
                    <span>
                      {{row.roleDescription}}
                    </span>
                  </td>
                  <td>
                    <span>{{row.firstName}} {{row.lastName}}</span>
                  </td>
                  <td>
                    <span> {{row.email}} </span>
                  </td>
                  <td>
                    <span>{{row.phone}}</span>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </div>
  </div>
}